import React from 'react';
import { PhoneIcon, MailIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-[#1a365d] text-white py-12" data-id="element-117">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-119">
          <div data-id="element-120">
            <h3 className="text-2xl font-bold mb-4" data-id="element-121">Jesús Silva</h3>
            <p className="text-gray-300" data-id="element-122">
              {t('Agente de Seguros de Protección Integral', 'Comprehensive Protection Insurance Agent')}
            </p>
          </div>
          <div data-id="element-123">
            <h4 className="text-lg font-semibold mb-4" data-id="element-124">
              {t('Contacto', 'Contact')}
            </h4>
            <div className="space-y-3" data-id="element-125">
              <a href="https://wa.me/13469022090" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-300 hover:text-[#d97706] transition-colors" data-id="element-126">
                <PhoneIcon className="w-5 h-5" data-id="element-127" />
                (346) 902-2090
              </a>
              <a href="mailto:jsilvainsurance@gmail.com" className="flex items-center gap-2 text-gray-300 hover:text-[#d97706] transition-colors" data-id="element-128">
                <MailIcon className="w-5 h-5" data-id="element-129" />
                jsilvainsurance@gmail.com
              </a>
            </div>
          </div>
          <div data-id="element-130">
            <h4 className="text-lg font-semibold mb-4" data-id="element-131">
              {t('Servicios', 'Services')}
            </h4>
            <ul className="space-y-2 text-gray-300" data-id="element-132">
              <li data-id="element-133">{t('Planes de Salud', 'Health Plans')}</li>
              <li data-id="element-134">{t('Seguros de Vida', 'Life Insurance')}</li>
              <li data-id="element-135">{t('Seguros de Accidentes', 'Accident Insurance')}</li>
              <li data-id="element-136">Medicare</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-gray-400 text-sm" data-id="element-137">
          <p data-id="element-138">
            &copy; {new Date().getFullYear()} Jesús Silva.{' '}
            {t('Todos los derechos reservados.', 'All rights reserved.')}
          </p>
          <div className="flex items-center gap-4" data-id="element-139">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-140">
              {t('Política de Privacidad', 'Privacy Policy')}
            </Link>
            <span data-id="element-141">|</span>
            <a href="/#contacto" className="hover:text-white transition-colors" data-id="element-142">
              {t('Contacto', 'Contact')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}